import { UserRole } from '../../../../shared/types';

export function seesWholeFirm(role: UserRole | undefined): boolean {
    return role === UserRole.BrokerAgentAssistant || role === UserRole.BrokerAgentAdmin;
}
